const config = {
    blogsentry: {
        uuid_: 75, 
        userName: 75, 
        title: 150, 
        urlTitle: 150, 
        alt_tag: 255, 
        statusByUserName: 75, 
        blog_type: 255,
    },
    cms_permissions: {
        permission: 255, 
        type: 255,
    },
    cms_roles: {
        name: 255,
    },
    cms_users: {
        email: 255, 
        title: 255, 
        firstName: 255, 
        lastName: 255, 
        suffix: 255, 
        password: 255, 
        bio: 255, 
        image: 255,
    },
    dental_learning_featured_evaluations: {
        category_name: 115,
    },
    dps_301_redirects: {
        inputUrl: 255, 
        outputUrl: 255,
    },
    dps_404_urls: {
        url: 255,
    },
    dps_admin_config: {
        entity: 150, 
        resource_type: 255, 
        resource_url: 255, 
        articleFilePath: 255, 
        articleHeader: 255,
    },
    dps_advertisement: {
        right_arch_banner_script: 45,
    },
    dps_article: {
        title: 200, 
        article_type: 20, 
        urlTitle: 150,
    },
    dps_article_type: {
        name: 255,
    },
    dps_articles: {
        title: 255, 
        embed_form_title: 255, 
        hubspot_form_id: 255, 
        call_to_action: 255, 
        pdf_link: 255, 
        article_type: 255, 
        thumbnail: 255, 
        thumbnail_path: 255, 
        urlTitle: 255, 
        ebookExternalLink: 255, 
        alt_tag: 255,
    },
    dps_becomeevaluator: {
        address_line1: 75, 
        address_line2: 75, 
        city: 255, 
        degree: 255, 
        dental_school: 150, 
        email: 255, 
        first_name: 255, 
        last_name: 255, 
        other_interest: 150, 
        refer_email: 255, 
        refer_friendname: 255, 
        speciality: 150, 
        state: 255, 
        year_graduated: 150, 
        zip: 255, 
        active: 255, 
        equipment: 255, 
        no_of_product: 255, 
        note: 255, 
        work_phone: 20,
    },
    dps_bulk_redirects: {
        source: 155, 
        destination: 155,
    },
    dps_buyers_guide: {
        buyers_url: 255, 
        buyers_value: 255, 
        category_name: 200, 
        imageFileName: 255, 
        imagePath: 255, 
        manufacturer_name: 200, 
        product_name: 200, 
        division: 255,
    },
    dps_category: {
        name: 150, 
        urlTitle: 150, 
        thumbnail: 255, 
        thumbnail_path: 255, 
        alt_tag: 255, 
        featured_info_form: 150,
    },
    dps_category_pillar: {
        question: 255, 
    },
    dps_category_contentfeed_display: {
    type: 255, 
    },
    dps_category_manufacturer: {
        categoty_name: 75,
    },
    dps_collaboration_associations: {
        class_type: 20, 
        collab_type: 10, 
        category_id: 255, 
        manufacturer_id: 255, 
        product_id: 255,
    },
    dps_continue_reading: {
        email: 255, 
        entity_type: 255, 
        first_name: 255, 
        ip: 255, 
        last_name: 255,
    },
    dps_contributors: {
        name: 255, 
        credentials: 255, 
        location: 255, 
    },
    dps_criteria: {
        criteriaName: 255,
    },
    dps_distributor: {
        address_line1: 75, 
        address_line2: 75, 
        address_line3: 75, 
        city: 75, 
        company_logo: 255, 
        company_url: 100, 
        contact_person: 75, 
        country: 75, 
        email: 75, 
        name: 150, 
        region: 75, 
        zip: 75,
    },
    dps_embed_form: {
        name: 255, 
        url_title: 255, 
        form_type: 255, 
        thumbnail_url: 255,
    },
    dps_evaluation_criteria: {
        criteriaName: 255, 
        criteriaVal: 45,
    },
    dps_gamification: {
        pageName: 255, 
        url: 200,
    },
    dps_h2_tag_entry: {
        classTypeName: 255, 
        h2_tag: 1000,
    },
    dps_icon: {
        image_url: 255, 
        title: 200, 
        icon_type: 20,
    },
    dps_manufacturer: {
        address_line1: 75, 
        address_line2: 75, 
        address_line3: 75, 
        city: 75, 
        company_url: 200, 
        contact_person: 75, 
        country: 75, 
        email: 75, 
        name: 150, 
        region: 75, 
        zip: 75, 
        facebook_link: 100, 
        fax: 75, 
        // google_link: 100, 
        twitter_link: 100, 
        // ARGI_RSN: 50, 
        // legacy_id: 20, 
        // demo_email: 75, 
        // rmi_email: 75, 
        // sample_email: 75, 
        urlTitle: 150, 
        instagram_link: 100, 
        linkedin_link: 100, 
        // b_id: 255, 
        alt_tag: 45, 
        // youtube_link: 100, 
        // external_link_display: 255,
    },
    dps_manufacturer_review_comments: {
        comment_title: 150, 
        username: 255, 
    },
    dps_manufacturer_review_details: {
        future_purchase: 255, 
        location: 255, 
        currently_own: 255, 
        manufacturer_recommend: 255, 
        notify_review_comments: 255, 
        practice_name: 255, 
        practice_zip: 255, 
        profession: 255, 
        receive_approved_email: 255,
    },
    dps_manufacturer_reviews: {
        ip_address: 255, 
        manufacturer_name: 255, 
        review_title: 150, 
        reviewToken: 255, 
        user_confirmation: 255, 
        user_email: 255, 
        user_name: 255, 
        user_nick_name: 255, 
        user_type: 255,
    },
    dps_mixiddetails: {
        mixId: 200, 
        entryId: 20,
    },
    dps_option: {
        option_text: 255,
    },
    dps_plan: {
        name: 150,
    },
    dps_podcasts: {
        name: 150, 
        file_type: 75, 
        type: 10, 
        image_url: 255, 
        urlTitle: 150,

    },
    dps_pop_ups: {
        title: 255, 
        header_text: 255, 
        description: 255, 
        link: 255, 
        button_text: 255, 
        image_url: 255, 
        membership: 255,
    },
    dps_product: {
        name: 150, 
        sku: 75, 
        // companyurl: 255, 
        // legacy_id: 20, 
        urlTitle: 150, 
        dps_url_title: 255, 
        // msrp: 10,
    },
    dps_product_attribute_details: {
        attribute_detail: 150,
    },
    dps_product_attributes: {
        attribute_name: 150, 
        is_good: 11,
    },
    dps_product_attributes_facet: {
        suffix: 30, 
        facet_values: 255,
    },
    dps_product_evaluation_criteria: {
        criteria_name: 255,
    },
    dps_product_evaluation_evaluator: {
        address_line1: 75, 
        address_line2: 75, 
        city: 75, 
        state: 75, 
        zip: 75,
    },
    dps_product_evaluations: {
        urlTitle: 150, 
        dps_url_title: 255, 
        website_url: 150,
    },
    dps_product_images: {
        imageType: 75, 
        image_url: 250, 
        name: 150, 
        alt_tag: 255, 
        alt_tag2: 255,
    },
    dps_product_review_comments: {
        comment_title: 150, 
        username: 255,
    },
    dps_product_review_details: {
        future_purchase: 255, 
        location: 255, 
        notify_review_comments: 255, 
        practice_name: 255, 
        practice_zip: 255, 
        currently_own: 255, 
        product_recommend: 255, 
        profession: 255, 
        receive_approved_email: 255,
    },
    dps_product_reviews: {
        helpful: 255, 
        review_title: 150, 
        reviewToken: 255, 
        user_confirmation: 255, 
        user_email: 255, 
        user_name: 255, 
        user_nick_name: 255, 
        user_type: 255, 
        product_name: 255, 
        ip_address: 255, 
        user_location: 255,
    },
    dps_product_sku: {
        name: 255, 
        sku: 255,
    },
    dps_product_techspec: {
        spec_name: 255,
    },
    dps_product_videos: {
        name: 150, 
        video_type: 75, 
        type: 10, 
        image_url: 255, 
        alt_tag: 255, 
        urlTitle: 150, 
        videoLink: 255,
    },
    dps_promotion: {
        external_link: 500, 
        image_url: 255, 
        title: 255, 
        urlTitle: 150, 
        external_link_display: 255, 
        alt_tag: 45,
    },
    dps_request: {
        city: 50, 
        country: 50, 
        degree: 50, 
        first_name: 50, 
        last_name: 50, 
        office_phone: 50, 
        practice_name: 100, 
        primary_field: 50, 
        state: 50, 
        type: 50, 
        zip: 10,
    },
    dps_rmi_category: {
        category_name: 150,
    },
    dps_sales_rep_clients: {
        company_name: 155, 
        company_owner: 155, 
        company_domain_name: 155, 
        id: 155,
    },
    dps_site_form_user_data: {
        ip_address: 115, 
        email: 300,
    },
    dps_sku_distributor: {
        buy_url: 255,
    },
    dps_subscribe: {
        address_line1: 75, 
        address_line2: 75, 
        born_city: 255, 
        city: 255, 
        degree: 255, 
        dentist_practice: 255, 
        email: 255, 
        first_name: 255, 
        items_purchased: 255, 
        last_name: 255, 
        occupation: 255, 
        patients_week: 255, 
        place_implants: 255, 
        practice_name: 255, 
        speciality: 255, 
        specify: 255, 
        spend_year: 255, 
        state: 255, 
        week_practice: 255, 
        zip: 255,
    },
    dps_survey_answer: {
        ip: 255, 
        emailAddress: 255, 
        comment: 255,
    },
    dps_templates: {
        template_name: 255, 
        template_category: 255,
    },
    dps_top_product: {
        name: 155, 
        url_title: 155, 
        dps_url_title: 255, 
        dps_top_productcol: 45,
    },
    dps_tracking: {
        object_type: 30, 
        action: 30, 
        ip_address: 255, 
        page_id: 100, 
        section_id: 100,
    },
    dps_urls: {
        original_url: 45, 
        new_url: 45,
    },
    dps_user_favorites: {
        fav_obj_type: 10,
    },
    dps_users: {
        age_id: 10, 
        degree: 10, 
        npid: 10, 
        practice_name: 150, 
        title: 25, 
        dental_school: 100, 
        display_name: 50, 
        omedaId: 255, 
        zip: 11, 
        legacy_email: 200, 
        legacy_role: 20, 
        legacy_username: 200, 
        first_name: 200, 
        last_name: 200,
    },
    dps_video_chapters: {
        description: 255
    },
    dps_video_timestamp_sections: {
        timestamp: 255,
        heading: 255
    },
    dynamic_personas: {
        website: 255, 
        name: 300, 
        type: 255, 
        details: 500, 
        ids: 500,
    },
    evaluation_sample_certificates: {
        email: 255, 
        uuid: 255, 
        product_name: 255, 
        first_name: 255, 
        last_name: 255, 
        practice_name: 255, 
        title: 255, 
        signature: 255, 
    },
    ims_team_data: {
        // PREVIOUS LIMIT ON CMS
        first_name: 30, 
        last_name: 30, 
        url: 30, 

        // CHARACTER LIMIT IN DB
        // first_name: 255, 
        // last_name: 255, 
        // url: 255, 
        role: 255, 
        phone: 255, 
        email: 255, 
        category: 255, 
        directory_page: 255, 
        image_url: 255,
    },
    journalarticle: {
        uuid_: 75, 
        userName: 75, 
        articleId: 75, 
        urlTitle: 150, 
        type_: 75, 
        structureId: 75, 
        templateId: 75, 
        layoutUuid: 75, 
        statusByUserName: 75,
    },
};

export default config;
